import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@dfl/mui-react-common';
import { ConfirmDialog } from '@dfl/mui-admin-layout';
import { useToggle } from '@dfl/hook-utils';
import ResendIcon from 'components/icons/ResendIcon';
import useResendClientConfirmation from 'modules/crm/clients/hooks/useResendClientConfirmation';

type Props = {
  email: string;
  verified?: boolean;
};

const ClientResendConfirmationRowAction = ({ email, verified }: Props) => {
  const { t } = useTranslation('common');
  const { isOpen, onClose, onOpen } = useToggle();
  const { mutate, isLoading: isSending, error } = useResendClientConfirmation(onClose);

  const handleConfirm = useCallback(() => {
    mutate({ email });
  }, [mutate, email]);

  return (
    <>
      <IconButton onClick={onOpen} tooltip={t('resend')} disabled={!!verified}>
        <ResendIcon width={18} height={18} color={verified ? '#bdbdbd' : 'black'} />
      </IconButton>
      <ConfirmDialog
        isLoading={isSending}
        open={isOpen}
        error={error}
        onClose={onClose}
        onConfirm={handleConfirm}
        confirmButtonText={t('common:confirmation.confirm')}
        title={t('crm:resendConfirmationEmail.title')}
        confirmationMessage={t('crm:resendConfirmationEmail.description')}
      />
    </>
  );
};

export default memo(ClientResendConfirmationRowAction);
